'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = require('./../../IconButton/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _MoreVertical = require('@ellucian/ds-icons/lib/MoreVertical');

var _MoreVertical2 = _interopRequireDefault(_MoreVertical);

var _Tooltip = require('./../../Tooltip/Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Icon button component for Action menu
 */
var ActionMenuIconButton = function ActionMenuIconButton(props) {
    var menuId = props.menuId,
        id = props.id,
        edsContext = props.edsContext,
        icon = props.icon,
        IconButtonProps = props.IconButtonProps,
        open = props.open,
        setOpen = props.setOpen,
        buttonRef = props.buttonRef;


    return _react2.default.createElement(
        _Tooltip2.default,
        { title: edsContext.formatMessage('component.ActionMenu.more'),
            enterDelay: 1000,
            enterNextDelay: 1000
        },
        _react2.default.createElement(
            _IconButton2.default,
            Object.assign({
                ref: buttonRef,
                disableRipple: true,
                'aria-label': edsContext.formatMessage('component.ActionMenu.more'),
                'aria-expanded': open,
                'aria-haspopup': 'true',
                'aria-controls': menuId || id,
                onClick: setOpen,
                color: 'gray',
                tabIndex: 0
            }, IconButtonProps),
            icon
        )
    );
};

ActionMenuIconButton.propTypes = {
    buttonRef: _propTypes2.default.object,
    open: _propTypes2.default.bool,
    setOpen: _propTypes2.default.func,
    /**
     * @ignore
     */
    edsContext: _propTypes2.default.object,
    icon: _propTypes2.default.node,

    /**
     * **DEPRECATED** Use `id` instead.
     *
     * Menu HTML ID for uniqueness.
     */
    menuId: _propTypes2.default.string,

    /**
     * Menu HTML ID for uniqueness.
     */
    id: _propTypes2.default.string,

    /**
     * Props applied to the IconButton that brings up the action menu
    */
    IconButtonProps: _propTypes2.default.object,

    /**
     * @ignore
     *
     * Externally set the initial open state of the action menu. For testing purposes only.
     */
    initialOpenOverride: _propTypes2.default.bool

};

ActionMenuIconButton.defaultProps = {
    icon: _react2.default.createElement(_MoreVertical2.default, null)
};

exports.default = ActionMenuIconButton;